import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type InquiryFile = {
  inquiry_file_id?: number; // 문의 파일 idx
  inquiry_id?: number; // 문의 idx
  file_name?: string; // 파일명
  file_url?: string; // 파일 url
  type?: string; // 타입
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] InquiryFile
   * --
   */
  getInquiryFiles: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_INQUIRY_FILE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] InquiryFile
   * --
   */
  getInquiryFile: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_INQUIRY_FILE, {
        inquiry_file_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] InquiryFile
   * --
   */
  createInquiryFile: async (body: InquiryFile) => {
    try {
      const res = await $http.post(APIConstant.CREATE_INQUIRY_FILE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] InquiryFile
   * --
   */
  updateInquiryFile: async (body: InquiryFile) => {
    try {
      const { inquiry_file_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_INQUIRY_FILE, {
        inquiry_file_id: inquiry_file_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] InquiryFile
   * --
   */
  deleteInquiryFile: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_INQUIRY_FILE, {
        inquiry_file_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] InquiryFile
   * --
   */
  bulkCreateInquiryFile: async (body: InquiryFile[]) => {
    try {
      const res = await $http.post(APIConstant.BULK_CREATE_INQUIRY_FILE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
